import styled from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

export const StyledFilterStateItem = styled.li.attrs({ as: Stack })`
    gap: 6px;
`;

export const StyledFiltersStateList = styled.ul.attrs({ as: Stack })`
    gap: 16px;

    &:not(:last-child) {
        margin-bottom: 16px;
    }
`;
